export default __webpack_public_path__ + "static/media/ico-graph-n.45efaa59.svg";